export const ROUTE_PATHS = {
  BASE_ROUTE: '/',
  CONTAINERS: '/containers',
  UPDATE_EXPIRY_DATE: '/update-expiry-date',
  CHANGE_TERMINAL: '/change-terminal',
  UPDATE_VOYAGE: '/update-voyage',
  DISPLAY_NOTIFICATIONS: '/display-notifications',
  REVOKE_VOYAGE: '/revoke-voyage',
  UNBLOCK_VOYAGE: '/unblock-voyage',
  DELETE_VOYAGE: '/delete-voyage',
  BLOCK_VOYAGE: '/block-voyage',
  ASSIGN_RELEASE_PARTY: '/assign-release-party',
  CONTAINER_DETAIL: '/containers/detail',
  CONTAINER_DETAIL_OVERVIEW: '/containers/:tabId',
  CONTAINER_RELEASE_ADD: '/commercial-release/add',
  CONTAINER_RELEASE_UPDATE: '/commercial-release/update',
  CONTAINER_SUBSCRIPTIONS: '/container-subscriptions',
  CONTAINER_SUBSCRIPTIONS_DETAIL: '/container-subscriptions/detail',
  SEARCH_PER_VOYAGE: '/search-containers',
  SEARCH_COMPANIES: '/search-companies',
  BILLING_INFO: '/billing-info',
  CREATE_MULTIPLE_RELEASES_UPLOAD: '/create-multiple-releases-upload',
  OVERRULE_CUSTOMS_LIGHT: '/overrule-customs-light',
};

export const maxNumberOfContainersProcessed = 1000;

const BASE_FAQ_URL = 'https://www.certifiedpickup.com/en/certified-pick-shipping-agent';
export const FAQ_PAGES = {
  ASSIGN_RELEASE_PARTY: `${BASE_FAQ_URL}#toewijzen`,
  CHANGE_TERMINAL: `${BASE_FAQ_URL}#terminal`,
  REVOKE_VOYAGE: `${BASE_FAQ_URL}#revoke`,
  UPDATE_EXPIRY_DATE: `${BASE_FAQ_URL}`,
  CREATE_COMMERCIAL_RELEASE: `${BASE_FAQ_URL}#aanmaken`,

  BLOCK_VOYAGE: `${BASE_FAQ_URL}`,
  DELETE_VOYAGE: `${BASE_FAQ_URL}`,
  UNBLOCK_VOYAGE: `${BASE_FAQ_URL}`,
  UPDATE_VOYAGE: `${BASE_FAQ_URL}`,
};
